import { createAsyncThunk } from "@reduxjs/toolkit";
import vocManaApi from 'api/vocManaApi';
import { formatQueryParams } from "helpers/format";
import 'react-toastify/dist/ReactToastify.css';

export const getVOCReasons = createAsyncThunk("VOCReasons", async (params: any = {}) => {
  try {
    const response = await vocManaApi.vocReasons(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getReasonAll = async (params: any = {}) => {
  try {
    const response = await vocManaApi.vocReasonsAll(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getReason = async (id: string | number, params: any = {}) => {
  try {
    const response = await vocManaApi.getVOCReason(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postReason = async (data: any = {}) => {
  try {
    const response = await vocManaApi.postVOCReason(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putReason = async (id: string | number, data: any = {}) => {
  try {
    const response = await vocManaApi.putVOCReason(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteReason = async (id: string | number, data: any = {}) => {
  try {
    const response = await vocManaApi.deleteVOCReason(id, data);
    return response;
  } catch (error) {
    return error;
  }
};
